import React from 'react';
import { 
  ChartBarIcon, 
  CurrencyDollarIcon, 
  KeyIcon, 
  UserGroupIcon,
  CogIcon,
  DocumentTextIcon,
  HomeIcon
} from '@heroicons/react/24/outline';
import logoUrl from '../../assets/AwareAI-logo.png';

interface SidebarProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

const navigation = [
  { name: 'Overview', href: 'overview', icon: HomeIcon },
  { name: 'Usage Analytics', href: 'analytics', icon: ChartBarIcon },
  { name: 'API Keys', href: 'keys', icon: KeyIcon },
  { name: 'Teams', href: 'teams', icon: UserGroupIcon },
  { name: 'Billing', href: 'billing', icon: CurrencyDollarIcon },
  { name: 'Reports', href: 'reports', icon: DocumentTextIcon },
  { name: 'Settings', href: 'settings', icon: CogIcon },
];

export const Sidebar: React.FC<SidebarProps> = ({ activeTab, onTabChange }) => {
  return (
    <div className="bg-white dark:bg-gray-800 shadow-sm h-full w-64 fixed left-0 top-0">
      <div className="flex items-center justify-center h-16 px-4 border-b border-gray-200 dark:border-gray-700">
        <img src={logoUrl} alt="AwareAI Ask Engine" className="h-10 w-auto" />
      </div>
      
      <nav className="mt-5 px-3">
        <div className="space-y-1">
          {navigation.map((item) => {
            const isActive = activeTab === item.href;
            return (
              <button
                key={item.name}
                onClick={() => onTabChange(item.href)}
                className={`${
                  isActive
                    ? 'bg-primary-50 dark:bg-primary-900/50 border-primary-500 text-primary-700 dark:text-primary-300'
                    : 'border-transparent text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 hover:text-gray-900 dark:hover:text-gray-100'
                } group flex items-center px-3 py-2 text-sm font-medium border-l-4 w-full text-left transition-colors duration-200`}
              >
                <item.icon
                  className={`${
                    isActive ? 'text-primary-500 dark:text-primary-400' : 'text-gray-400 dark:text-gray-500 group-hover:text-gray-500 dark:group-hover:text-gray-400'
                  } mr-3 h-5 w-5`}
                  aria-hidden="true"
                />
                {item.name}
              </button>
            );
          })}
        </div>
      </nav>
      
      <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-gray-200 dark:border-gray-700">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <div className="h-8 w-8 rounded-full bg-primary-100 dark:bg-primary-900 flex items-center justify-center">
              <span className="text-sm font-medium text-primary-700 dark:text-primary-300">JD</span>
            </div>
          </div>
          <div className="ml-3">
            <p className="text-sm font-medium text-gray-700 dark:text-gray-300">John Doe</p>
            <p className="text-xs text-gray-500 dark:text-gray-400">Administrator</p>
          </div>
        </div>
      </div>
    </div>
  );
};